module.exports = __webpack_public_path__ + "static/media/giveaway.f7bda220.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/workshop/giveaway.png
// module id = 603
// module chunks = 2